import { yupResolver } from "@hookform/resolvers/yup";
import {useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  useCreateMantenimiento,
  useUpdateMantenimiento,
  usefetchActivos,
} from "@/shared/actions/erp";
import {
  SampleTable,
  SingleButton,
  SingleTableBoxScene,
  TabTextLabel,
  CustomSearch,
  SampleDatePicker,
  SampleCheckbox,
  
  CustomNumberTextField,
  CustomAutocomplete,
  CustomTextField
} from "@/shared/components/ui";
import {
  Activos,
  Mantenimiento,
} from "@/shared/interfaces";
import { Button,Grid,InputAdornment,Paper, TextField } from "@mui/material";
import { gridSizeMdLg4, useTableFilter} from "@/shared";
import { MRT_ColumnDef } from "material-react-table";
import { useUiStore } from "@/store/ui";
import DeleteIcon from "@mui/icons-material/Delete";
import { newMantenimientoSchema } from "@/shared";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Empleado } from "@/shared/interfaces/erp/empleados";
import { useFetchEmpleados } from "@/shared/actions/erp/empleados";


const returnUrlMantenimiento = "/activos/mantenimiento";


type SaveFormData = {
  codigo:string;
  fecha_inicio:string;
  fecha_fin:string;
  costo:string;
  estado:boolean;
  descripcion:string;
  encargado:string;
  activo?: string;
};

export interface SaveMantenimientoInterface {
  titlePage: string;
  editMantenimiento?: Mantenimiento;
}

const SaveMantenimiento: React.FC<SaveMantenimientoInterface> = ({
  titlePage,
  editMantenimiento,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  const [open, setOpen] = useState(false);

  ///* mutations
  const createMantenimientoMutation = useCreateMantenimiento({navigate, returnUrl:returnUrlMantenimiento});
  const updateMantenimientoMutation = useUpdateMantenimiento({navigate, returnUrl:returnUrlMantenimiento});
  const [productos, setProductos] = useState<Activos[]>([]);
  const [productoId,setProductoId]= useState<number|string>("");

  ///* fetch data


  ///* form

  const form = useForm<SaveFormData>({
    resolver: yupResolver(newMantenimientoSchema),
    defaultValues: {
      estado: false,
    },
  });


  const { globalFilter, pagination, searchTerm, onChangeFilter, cleanFilter } =
    useTableFilter();
  const { pageIndex } = pagination;
  const { data: ProductosPagingRes } = usefetchActivos({
    page: pageIndex + 1,
    codigo_barras: searchTerm.toUpperCase(),
  });
  const filteredProductos = useMemo(() => {
    if (!searchTerm) return ProductosPagingRes?.data?.data;

    return ProductosPagingRes?.data?.data.filter((item) =>
      item.codigo?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [ProductosPagingRes, searchTerm]);
  
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors,isValid },
  } = form;

  const setAlert = useUiStore.getState().setAlert;
  const agregarProducto = (producto: Activos) => {
      setProductoId(producto.codigo!)
      setProductos(prevProductos => [...prevProductos, producto]);
  };

  const { data: dataUser, isLoading: isLoadingUser } =
    useFetchEmpleados({
      enabled: true,
      params: {
        page_size: 1000,
      }
    });

  const columnsInsertProducto: MRT_ColumnDef<Activos>[] =
  useMemo<MRT_ColumnDef<Activos>[]>(
    () => [
      {
        accessorKey: "actions",
        header: "Acciones",
        Cell: ({ row }) => {
          return (
            <SingleButton
              newCustomButton
              label="AGREGAR"
              variant="text"
              color="success"
              showIcon={false}
              disabled={productos.length > 0}
              onClick={() => {
                agregarProducto(row.original);
              }}
            />
          );
        },
      },
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
      },
      {
        accessorKey: "codigo",
        header: "codigo",
      },
      {
        accessorKey: "nombre",
        header: "nombre",
      },
    ],
    [agregarProducto, productos]
  );
  // Función para eliminar un producto
const eliminarProducto = (idActivo: string) => {
  setProductos(prevProductos => prevProductos.filter(producto => producto.id_activo !== idActivo));
  setProductoId("");
};
const today = new Date().toISOString();

const columnsProductosDetallePedidosDb2: MRT_ColumnDef<Activos>[] =
  useMemo<MRT_ColumnDef<Activos>[]>(
    () => [
      {
        accessorKey: "remove",
        header: "Eliminar",
        Cell: ({ row }) => {
          return (
            <SingleButton
              newCustomButton
              iconButton
              color="error"
              startIcon={<DeleteIcon />}
              onClick={() => {
                eliminarProducto(row.original.id_activo!);
              }}
            />
          );
        },
      },
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
      },
      {
        accessorKey: "codigo",
        header: "codigo",
      },
      {
        accessorKey: "nombre",
        header: "nombre",
      },
    ],
    [eliminarProducto]
  );

  const onSave = () => {
    if (!isValid) {
      return;
    }
    const formData = {
      ...form.getValues(),
      activo: productoId,
    } as any;
    if (!formData.activo) {
      setAlert(true,'Por favor, selecciona al menos un producto.','error');
      return;
    }
    ///* upd
    if (editMantenimiento?.id_mantenimiento_activo) {
      return updateMantenimientoMutation.mutate(
        {
          id: editMantenimiento.id_mantenimiento_activo,
          data: {
            ...editMantenimiento
          } as any,
        },
        {
          onSuccess: () => {
            reset(); // reset form after successful update
          },
        }
      );
    }

    ///* create
    return createMantenimientoMutation.mutate(
      {
        ...form.getValues(),
        fecha_inicio: form.getValues().fecha_inicio ? new Date(form.getValues().fecha_inicio).toISOString().slice(0, 10) : "",
        fecha_fin: form.getValues().fecha_fin? new Date(form.getValues().fecha_fin).toISOString().slice(0, 10) : "",
        costo: form.getValues().costo || "",
        activo: productoId
      } as any,
      {
        onSuccess: () => {
          reset(); // reset form after successful creation
        },
      }
    )
  }
  const productAddedRef = useRef(false);

  useEffect(() => {
    if (editMantenimiento?.id_mantenimiento_activo && !productAddedRef.current) {
      setShrink(true);
      reset({
        ...editMantenimiento
      } as any);
      agregarProducto(editMantenimiento?.activo_data!);
      productAddedRef.current = true;
    }
  },
  [editMantenimiento]
  );
  return (
    <>
      <SingleTableBoxScene
        title={titlePage}
        enableBackBtn={true}
        backPageUrl="/activos/mantenimiento"
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, () => {/* 
          setAlert(true, 'Faltan campos por llenar', 'error'); */
          })}>
                    <SampleDatePicker
            label="fecha inicio"
            control={form.control}
            error={errors.fecha_inicio}
            helperText={errors.fecha_inicio?.message}
            name="fecha_inicio"
            textFieldKey="fecha_inicio"
            size={gridSizeMdLg4}
            defaultValue={today}
          />
            <CustomTextField
            label="codigo"
            name="codigo"
            control={form.control}
            error={errors.codigo}
            helperText={errors.codigo?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
           <CustomNumberTextField
        label="Costo"
        name="costo"
        control={form.control}
        defaultValue={form.getValues().costo || ''}
        error={errors.costo}
        helperText={errors.costo?.message ?? ''}
        shrink={shrink}
        min={0}
        max={100}
        startAdornment={<InputAdornment position="start">%</InputAdornment>}
      />
       <CustomAutocomplete<Empleado>
            label="Encargado"
            name="encargado"
            options={dataUser?.data?.data || []}
            valueKey="razon_social"
            actualValueKey="codigo"
            defaultValue={form.getValues().encargado || ''}
            isLoadingData={isLoadingUser}
            control={form.control}
            error={errors.encargado}
            helperText={errors.encargado?.message}
          />
           <Grid item {...gridSizeMdLg4}>
                <TextField
                  {...register("descripcion", {
                    required: "La descripción es obligatoria",
                  })}
                  id="descripcion"
                  label="Descripción"
                  fullWidth
                  rows={4}
                  multiline
                  error={Boolean(errors.descripcion)}
                  helperText={errors.descripcion?.message}
                />
              </Grid>
                    <SampleDatePicker
            label="fecha fin"
            control={form.control}
            error={errors.fecha_fin}
            helperText={errors.fecha_fin?.message}
            name="fecha_fin"
            textFieldKey="fecha_fin"
            size={gridSizeMdLg4}
            defaultValue={today}
          />
                      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado|| false}
        isState
      />
        <Grid container spacing={3}>
            <Paper className="paper-producto">
              <Grid
                container
                spacing={1}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Grid item>
                  <TabTextLabel
                    text={"Activos Seleccionados"}
                    mt={0}
                    pb={0}
                    pl={0}
                    pt={0}
                  />
                </Grid>
                <Grid item>
  <Button onClick={() => setOpen(true)}>
    Agregar Activo
  </Button>
</Grid>
                <div className="linea"></div>
                <Grid item xs={12}>
                <SampleTable<Activos>
              columns={columnsProductosDetallePedidosDb2}
              data={productos}
            />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <ScrollableDialogProps
      open={open}
      title="Activos"
      cancelTextBtn="Cerrar"
      // actions
      onClose={() => setOpen(false)}
      // content
      minWidth="60%"
      contentNode={
        <>
          <Grid container spacing={3}>
  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <Grid container item xs={12} spacing={3}>
      <Grid item lg={8}>
        <CustomSearch
          value={globalFilter}
          onChange={onChangeFilter}
          cleanFilter={cleanFilter}
          text="Buscar por codigo de activo"
        />
      </Grid>
    </Grid>
    <SampleTable<any>
      columns={columnsInsertProducto as any}
      data={filteredProductos || []}
    />
  </Grid>
</Grid>
        </>
      }
    />
    </SingleTableBoxScene>
    </>
  );
};

export default SaveMantenimiento;
